<!-- ─────────────────────────────────────────────────────────────────────────
     AllStateCiTileComponent  –  All-State Critical Illness 100k
     Differences from LifeInsuranceTileComponent:
       • ONE checkbox labelled SINGLE (member only) or FAMILY (has dependents)
       • Separate smoker/non-smoker for Member + (optionally) Spouse
       • Backend currently only provides `member` key; price calcs done by parent
     ───────────────────────────────────────────────────────────────────────── -->

<div class="flex flex-col gap-2 text-xs mx-2 my-3">

  <!-- ── Total row ────────────────────────────────────────────────────────── -->
  <div class="flex px-1.5 items-center justify-between font-semibold">
    <div class="font-semibold text-lg md:text-xl">{{ lang.Total }}</div>
    <div class="text-end text-lg md:text-xl">
      <p class="text-end w-full outline-none">
        ${{ allFormData[addonKey]?.total || 0 | number : "1.2-2" }}
      </p>
    </div>
  </div>

  <!-- ── SINGLE / FAMILY checkbox ─────────────────────────────────────────── -->
  <div class="grid grid-cols-4 gap-2 lg:gap-4 items-center justify-between">
    <div class="col-span-3 flex gap-2 items-center">
      <input
        id="planCheckCI{{ addonKey }}-MEMBER"
        type="checkbox"
        attr.data="{{ pkg.name }}##{{ group.name }}##{{
          addonKey
        }}##{{
          plan.productAddonss[product][k].calculatedTax.price
        }}##0##0##0##{{ plan.id }}##{{ plan.fusebillId }}##{{
          plan.frqMonthly
        }}##{{ pkg.optIn }}##{{ group.disallowedPlanLevels }}##{{
          group.parentId
        }}##{{ group.id }}##{{ plan.name }}##{{ plan.planLevel }}##{{
          plan.packageId
        }}##0##{{ plan.planOptions }}##{{
          plan.productAddonss[product][k].id
        }}##{{ plan.productAddonss[product][k].plan_level.id }}##{{ plan.isBundle }}"
        name="{{ addonKey }}-member"
        class="w-6 h-6 my-auto flex-shrink-0 rounded cursor-pointer"
        (change)="onCheckboxChangePLocal(
          $event,
          addonKey,
          'member',
          'coverage',
          plan.productAddonss[product][k]
        )" />
      <label
        [htmlFor]="'planCheckCI' + addonKey + '-MEMBER'"
        class="mr-2 lg:mr-2 capitalize text-white w-full h-full label-text mt-3 text-[12px] font-semibold">
        <!-- Label: SINGLE when no dependents, FAMILY otherwise -->
        {{ isSinglePlan ? (lang.SINGLE || 'SINGLE') : (lang.FAMILY || 'FAMILY') }}
      </label>
    </div>
    <div class="col-span-1 text-white text-right font-semibold">
      <p class="bg-transparent text-end w-full h-full my-auto text-lg outline-none">
        ${{ allFormData[addonKey]?.member?.premium || 0 | number : "1.2-2" }}
      </p>
    </div>
  </div>

  <!-- ── Smoker questions ──────────────────────────────────────────────────── -->
  <div class="grid grid-cols-1 gap-2">
    <div class="col-span-1 text-base md:text-xl mt-3 text-[12px] text-white">

      <!-- ── Member smoker ─────────────────────────────────────────────────── -->
      <p class="font-semibold mb-1 text-[11px] opacity-80" *ngIf="!isSinglePlan">
        {{ lang.MEMBER || 'Member' }}
      </p>
      <p>
        In the last 12 months, have you used, in any form whatsoever, tobacco,
        nicotine or cannabis mixed with tobacco?
      </p>

      <div class="grid grid-cols-3 mt-2">
        <!-- Yes -->
        <div class="flex justify-center items-center gap-2">
          <input type="radio"
            class="member-{{ addonKey }}-yes w-6 h-6 my-auto outline-none cursor-pointer"
            id="ci-member-{{ addonKey }}-yes"
            name="ci-member-{{ addonKey }}"
            attr.data="{{ pkg.name }}##{{ group.name }}##{{
              addonKey
            }}##{{
              plan.productAddonss[product][k].calculatedTax.price
            }}##0##0##0##{{ plan.id }}##{{ plan.fusebillId }}##{{
              plan.frqMonthly
            }}##{{ pkg.optIn }}##{{ group.disallowedPlanLevels }}##{{
              group.parentId
            }}##{{ group.id }}##{{ plan.name }}##{{ plan.planLevel }}##{{
              plan.packageId
            }}##0##{{ plan.planOptions }}##{{
              plan.productAddonss[product][k].id
            }}##{{ plan.productAddonss[product][k].plan_level.id }}##{{ plan.isBundle }}"
            [disabled]="isMemberRadioDisabled()"
            [checked]="
              allFormData[addonKey]?.member?.isSmoker === 'yes'
            "
            value="yes"
            (change)="onRadioChangeLocal(
              $event,
              addonKey,
              'member',
              plan.planOptions,
              plan,
              plan.productAddonss[product][k],
              pkg,
              group,
              plan.productAddonss[product][k].member
            )" />
          <label [htmlFor]="'ci-member-' + addonKey + '-yes'"
            class="w-full mr-2 text-white text-[12px]">
            {{ lang.Yes }}
          </label>
        </div>
        <!-- No -->
        <div class="flex justify-center items-center gap-2">
          <input type="radio"
            class="member-{{ addonKey }}-no w-6 h-6 my-auto outline-none cursor-pointer"
            id="ci-member-{{ addonKey }}-no"
            name="ci-member-{{ addonKey }}"
            attr.data="{{ pkg.name }}##{{ group.name }}##{{
              addonKey
            }}##{{
              plan.productAddonss[product][k].calculatedTax.price
            }}##0##0##0##{{ plan.id }}##{{ plan.fusebillId }}##{{
              plan.frqMonthly
            }}##{{ pkg.optIn }}##{{ group.disallowedPlanLevels }}##{{
              group.parentId
            }}##{{ group.id }}##{{ plan.name }}##{{ plan.planLevel }}##{{
              plan.packageId
            }}##0##{{ plan.planOptions }}##{{
              plan.productAddonss[product][k].id
            }}##{{ plan.productAddonss[product][k].plan_level.id }}##{{ plan.isBundle }}"
            [disabled]="isMemberRadioDisabled()"
            [checked]="
              allFormData[addonKey]?.member?.isSmoker === 'no'
            "
            value="no"
            (change)="onRadioChangeLocal(
              $event,
              addonKey,
              'member',
              plan.planOptions,
              plan,
              plan.productAddonss[product][k],
              pkg,
              group,
              plan.productAddonss[product][k].member
            )" />
          <label [htmlFor]="'ci-member-' + addonKey + '-no'"
            class="w-full mr-2 text-white text-[12px]">
            {{ lang.No }}
          </label>
        </div>
      </div>

      <!-- ── Spouse smoker (only when form says user has a spouse) ───────────── -->
      <div *ngIf="hasSpouse" class="mt-4">
        <p class="font-semibold mb-1 text-[11px] opacity-80">{{ lang.SPOUSE || 'Spouse' }}</p>
        <p>
          In the last 12 months, have you used, in any form whatsoever, tobacco,
          nicotine or cannabis mixed with tobacco?
        </p>

        <div class="grid grid-cols-3 mt-2">
          <!-- Yes -->
          <div class="flex justify-center items-center gap-2">
            <input type="radio"
              class="spouse-{{ addonKey }}-yes w-6 h-6 my-auto outline-none cursor-pointer"
              id="ci-spouse-{{ addonKey }}-yes"
              name="ci-spouse-{{ addonKey }}"
              attr.data="{{ pkg.name }}##{{ group.name }}##{{
                addonKey
              }}##{{
                plan.productAddonss[product][k].calculatedTax.price
              }}##0##0##0##{{ plan.id }}##{{ plan.fusebillId }}##{{
                plan.frqMonthly
              }}##{{ pkg.optIn }}##{{ group.disallowedPlanLevels }}##{{
                group.parentId
              }}##{{ group.id }}##{{ plan.name }}##{{ plan.planLevel }}##{{
                plan.packageId
              }}##0##{{ plan.planOptions }}##{{
                plan.productAddonss[product][k].id
              }}##{{ plan.productAddonss[product][k].plan_level.id }}##{{ plan.isBundle }}"
              [disabled]="isSpouseRadioDisabled()"
              [checked]="
                allFormData[addonKey]?.spouse?.isSmoker === 'yes'
              "
              value="yes"
              (change)="onRadioChangeLocal(
                $event,
                addonKey,
                'spouse',
                plan.planOptions,
                plan,
                plan.productAddonss[product][k],
                pkg,
                group,
                plan.productAddonss[product][k].member
              )" />
            <label [htmlFor]="'ci-spouse-' + addonKey + '-yes'"
              class="w-full mr-2 text-white text-[12px]">
              {{ lang.Yes }}
            </label>
          </div>
          <!-- No -->
          <div class="flex justify-center items-center gap-2">
            <input type="radio"
              class="spouse-{{ addonKey }}-no w-6 h-6 my-auto outline-none cursor-pointer"
              id="ci-spouse-{{ addonKey }}-no"
              name="ci-spouse-{{ addonKey }}"
              attr.data="{{ pkg.name }}##{{ group.name }}##{{
                addonKey
              }}##{{
                plan.productAddonss[product][k].calculatedTax.price
              }}##0##0##0##{{ plan.id }}##{{ plan.fusebillId }}##{{
                plan.frqMonthly
              }}##{{ pkg.optIn }}##{{ group.disallowedPlanLevels }}##{{
                group.parentId
              }}##{{ group.id }}##{{ plan.name }}##{{ plan.planLevel }}##{{
                plan.packageId
              }}##0##{{ plan.planOptions }}##{{
                plan.productAddonss[product][k].id
              }}##{{ plan.productAddonss[product][k].plan_level.id }}##{{ plan.isBundle }}"
              [disabled]="isSpouseRadioDisabled()"
              [checked]="
                allFormData[addonKey]?.spouse?.isSmoker === 'no'
              "
              value="no"
              (change)="onRadioChangeLocal(
                $event,
                addonKey,
                'spouse',
                plan.planOptions,
                plan,
                plan.productAddonss[product][k],
                pkg,
                group,
                plan.productAddonss[product][k].member
              )" />
            <label [htmlFor]="'ci-spouse-' + addonKey + '-no'"
              class="w-full mr-2 text-white text-[12px]">
              {{ lang.No }}
            </label>
          </div>
        </div>
      </div>

    </div>

    <!-- ── Range slider (uses member data from backend) ──────────────────────── -->
    <div class="">
      <div>
        <p class="block my-3 text-center font-semibold mb-2 text-[12px]">
          ${{ plan.productAddonss[product][k].member.maximumCoverageWithoutEvidence / 1000 | number }}k
        </p>
        <div>
          <!-- Edge-only absolute tick marks -->
          <div *ngIf="
            plan.productAddonss[product][k].member.maximumCoverageWithEvidence &&
            plan.productAddonss[product][k].member.minimumCoverage
          " class="range-ticks flex justify-between mt-2">
            <ng-container *ngFor="
              let tick of generateTicks(
                plan.productAddonss[product][k].member.maximumCoverageWithEvidence
              );
              let i = index; let last = last
            ">
              <span *ngIf="i === 0 || last" class="tick" [ngStyle]="{
                position: 'absolute',
                left: i === 0 ? '0.4%' : '99.6%',
                top: '9px',
                width: '2px',
                height: '6px',
                backgroundColor: 'white'
              }"></span>
            </ng-container>
          </div>

          <div class="range-slider-container">
            <div class="range-slider-wrapper">
              <input type="range"
                attr.data="{{ pkg.name }}##{{ group.name }}##{{
                  addonKey
                }}##{{
                  plan.productAddonss[product][k].calculatedTax.price
                }}##0##0##0##{{ plan.id }}##{{ plan.fusebillId }}##{{
                  plan.frqMonthly
                }}##{{ pkg.optIn }}##{{ group.disallowedPlanLevels }}##{{
                  group.parentId
                }}##{{ group.id }}##{{ plan.name }}##{{ plan.planLevel }}##{{
                  plan.packageId
                }}##0##{{ plan.planOptions }}##{{
                  plan.productAddonss[product][k].id
                }}##{{ plan.productAddonss[product][k].plan_level.id }}##{{ plan.isBundle }}"
                [disabled]="!allFormData[addonKey]?.member?.isSmoker"
                id="{{ addonKey }}-ci-member-rangeSlider"
                name="{{ addonKey }}-ci-member-rangeSlider"
                [(ngModel)]="plan.productAddonss[product][k].member.maximumCoverageWithoutEvidence"
                [ngModelOptions]="{ standalone: true }"
                (change)="onRangeChangeLocal(
                  $event,
                  addonKey,
                  'member',
                  plan.planOptions,
                  plan,
                  plan.productAddonss[product][k],
                  pkg,
                  group,
                  $event,
                  plan.productAddonss[product][k].member
                )"
                [min]="0"
                [max]="plan.productAddonss[product][k].member.maximumCoverageWithEvidence"
                [step]="plan.productAddonss[product][k].member.minimumCoverage"
                [ngStyle]="{
                  background: getSliderBackground(
                    plan.productAddonss[product][k].member.maximumCoverageWithoutEvidence,
                    plan.productAddonss[product][k].member.maximumCoverageWithEvidence,
                    plan.productAddonss[product][k].member.minimumCoverage,
                    plan.productAddonss[product][k].member.defaultRange
                  )
                }"
                class="my-2 border appearance-none w-full h-4 rounded-md focus:outline-none" />

              <!-- Guaranteed Approval label -->
              <p class="name-label leading-4 text-[10px]" [ngStyle]="{ 'width.%': greenValue }">
                {{ lang.Guaranteed_Approval }}
              </p>
              @if (showyellowbar) {
                <p class="name-label leading-4 text-[10px]"
                   [ngStyle]="{ 'right.%': 0 }" style="top:-10px">
                  {{ lang.Pending_Approval }}
                </p>
              }

              <!-- Tick markers: smart filter – all 4 for clean ranges, 2 for non-round -->
              <div class="range-ticks1">
                <ng-container *ngFor="let val of rangeValues; let i = index; let last = last">
                  <span *ngIf="i === 0 || last || val % 1000 === 0" class="tick1"></span>
                </ng-container>
              </div>
            </div>

            <!-- Range labels -->
            <div class="range-labels">
              <ng-container *ngFor="let val of rangeValues; let i = index; let last = last">
                <span *ngIf="i === 0 || last || val % 1000 === 0" class="range-label">
                  ${{ val / 1000 | number:'1.0-0' }}k
                </span>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
      <br />
    </div>
  </div>

</div>
